<!--<meSvg [svgName]='first ? "delete_square2&44":"delete_square1&44"'-->
<!--       (click)='first ? null : deleteItem()' [disabled]='reqPending'></meSvg>-->

<meSvg [svgName]='disabled ? "delete_square2&44":"delete_square1&44"'
       (click)='disabled ? null : deleteItem()' [disabled]='reqPending || disabled'></meSvg>